import React from "react";
import { PhoneOutgoing, Grid3x3 } from "lucide-react";

import { Button } from "../ui/button";
import { useSoftphone, ligarPara, abrir } from "../../softphone/store";
import { paraDiscagem } from "../../softphone/discagem";

// Botoes de ligacao SIP no cabecalho do ticket (softphone/PBX). Diferente do
// CallButton, que e a voz sobre WhatsApp (Wavoip).
//
//  - status do ramal (bolinha colorida)
//  - ligar direto para o contato do ticket (numero convertido)
//  - abrir o discador para digitar/editar antes

const rotuloReg = {
	registered: "Ramal online",
	connecting: "Ramal conectando…",
	unregistered: "Ramal offline",
	failed: "Ramal com falha",
};
const corReg = {
	registered: "bg-emerald-500",
	connecting: "bg-amber-500",
	unregistered: "bg-gray-400",
	failed: "bg-red-500",
};

const SipCallButtons = ({ ticket }) => {
	const sp = useSoftphone();

	// So aparece se o usuario tem ramal configurado.
	if (!sp.conta) return null;

	const discado = paraDiscagem(ticket?.contact?.number);
	const podeLigar =
		sp.regState === "registered" &&
		!ticket?.isGroup &&
		discado.length >= 10;

	const ligar = () => {
		if (podeLigar) ligarPara(discado);
	};

	return (
		<div className="flex items-center gap-1">
			{/* status do ramal */}
			<span
				title={rotuloReg[sp.regState] || sp.regState}
				className={`h-2.5 w-2.5 rounded-full ${corReg[sp.regState]}`}
			/>

			{/* ligar direto para o contato */}
			<Button
				variant="ghost"
				size="icon"
				className="h-8 w-8"
				aria-label="Ligar para o contato (VoIP)"
				title={
					podeLigar
						? `Ligar para ${discado}`
						: "Ligacao VoIP indisponivel para este contato"
				}
				disabled={!podeLigar}
				onClick={ligar}
			>
				<PhoneOutgoing className="h-4 w-4" />
			</Button>

			{/* abrir o discador */}
			<Button
				variant="ghost"
				size="icon"
				className="h-8 w-8"
				aria-label="Abrir discador (VoIP)"
				title="Abrir discador"
				onClick={abrir}
			>
				<Grid3x3 className="h-4 w-4" />
			</Button>
		</div>
	);
};

export default SipCallButtons;
